import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Book1,
  Colorfilter,
  Edit2,
  InfoCircle,
  Lock,
  MessageQuestion,
  Notification,
  Share,
  ShieldSecurity,
  User as UserIcon,
} from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import { useAppTheme } from "../../app/providers/ThemeProvider";
import {
  SettingsCard,
  SettingsFooterNote,
  SettingsMenuItem,
  SettingsSection,
  SettingsSectionTitle,
  SettingsToggleItem,
} from "../../shared/components/SettingsMenuItem";
import { Main, SectionHeader, SectionTitle } from "../Register/styles";

const SettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const { isHighContrast, toggleHighContrast } = useAppTheme();

  const handleShare = async () => {
    const url = window.location.origin;
    const text =
      "Conheça o Bilíngua — sinalário de Libras bilíngue para aprender e se comunicar!";
    try {
      if (navigator.share) {
        await navigator.share({ title: "Bilíngua", text, url });
      } else {
        await navigator.clipboard.writeText(`${text} ${url}`);
        // eslint-disable-next-line no-alert
        window.alert("Link copiado para a área de transferência.");
      }
    } catch {
      /* cancelado */
    }
  };

  return (
    <MobileLayout headerTitle="Configurações" headerType="private">
      <Main style={{ maxWidth: 600 }}>
        <SectionHeader>
          <SectionTitle>Configurações</SectionTitle>
        </SectionHeader>

        <SettingsSection>
          <SettingsSectionTitle>Conta</SettingsSectionTitle>
          <SettingsCard>
            <SettingsMenuItem
              title="Editar perfil"
              description="Nome, foto e informações pessoais"
              icon={<UserIcon size={22} variant="Bold" />}
              onClick={() => navigate("/edit-account")}
            />
            <SettingsMenuItem
              title="Alterar senha"
              description="Atualize sua senha de acesso"
              icon={<Lock size={22} variant="Bold" />}
              onClick={() => navigate("/change-password")}
            />
            <SettingsMenuItem
              title="Privacidade"
              description="Dados e preferências de privacidade"
              icon={<ShieldSecurity size={22} variant="Bold" />}
              onClick={() => navigate("/privacy")}
            />
            <SettingsMenuItem
              title="Notificações"
              description="Ver alertas e avisos"
              icon={<Notification size={22} variant="Bold" />}
              onClick={() => navigate("/notificacoes")}
            />
          </SettingsCard>
        </SettingsSection>

        <SettingsSection>
          <SettingsSectionTitle>Personalização</SettingsSectionTitle>
          <SettingsCard>
            <SettingsMenuItem
              title="Personalização"
              description="Tema, cor de destaque e aparência"
              icon={<Colorfilter size={22} variant="Bold" />}
              onClick={() => navigate("/settings/personalization")}
            />
          </SettingsCard>
        </SettingsSection>

        <SettingsSection>
          <SettingsSectionTitle>Acessibilidade</SettingsSectionTitle>
          <SettingsCard>
            <SettingsToggleItem
              title="Alto contraste"
              description="Melhora a legibilidade de textos e ícones"
              checked={isHighContrast}
              onToggle={toggleHighContrast}
            />
          </SettingsCard>
        </SettingsSection>

        <SettingsSection>
          <SettingsSectionTitle>Suporte</SettingsSectionTitle>
          <SettingsCard>
            <SettingsMenuItem
              title="Perguntas frequentes"
              description="Dúvidas comuns sobre o Bilíngua"
              icon={<MessageQuestion size={22} variant="Bold" />}
              onClick={() => navigate("/ajuda")}
            />
            <SettingsMenuItem
              title="Avisos"
              description="Notícias e comunicados"
              icon={<Notification size={22} variant="Bold" />}
              onClick={() => navigate("/avisos")}
            />
            <SettingsMenuItem
              title="Sugestões"
              description="Enviar ou ver suas ideias"
              icon={<Edit2 size={22} variant="Bold" />}
              onClick={() => navigate("/sugestoes")}
            />
            <SettingsMenuItem
              title="Compartilhar app"
              description="Indique o Bilíngua para amigos"
              icon={<Share size={22} variant="Bold" />}
              onClick={() => {
                handleShare().catch(() => undefined);
              }}
            />
            <SettingsMenuItem
              title="Contribuir"
              description="Apoie o projeto Bilíngua HUB"
              icon={<Book1 size={22} variant="Bold" />}
              onClick={() => {
                window.open(
                  "https://www.bilinguahub.com.br/quero-apoiar",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            />
            <SettingsMenuItem
              title="Contato e suporte"
              description="Fale com a equipe"
              icon={<InfoCircle size={22} variant="Bold" />}
              onClick={() => navigate("/apoiar")}
            />
          </SettingsCard>
        </SettingsSection>

        <SettingsSection>
          <SettingsSectionTitle>Sobre</SettingsSectionTitle>
          <SettingsCard>
            <SettingsMenuItem
              title="Sobre o Bilíngua"
              description="Sinalário, parceiros e missão"
              icon={<InfoCircle size={22} variant="Bold" />}
              onClick={() => navigate("/about")}
            />
          </SettingsCard>
        </SettingsSection>

        <SettingsFooterNote>
          O Bilíngua pode exibir anúncios para manter o acesso gratuito à
          plataforma.
        </SettingsFooterNote>
      </Main>
    </MobileLayout>
  );
};

export default SettingsPage;
